import React, {useEffect, useRef, useState} from "react";
import {Card, Empty, Spin, Timeline, Typography} from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";

import {getFobHistory} from "../../helpers/fob";
import {messageType, showMessages} from "../../helpers/message";
import {ucFirst} from "../../helpers/misc";

import "./AccessKey.less";

const AccessKeyHistory = ({refreshFobs}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [loading, setLoading] = useState(false);

    const [fobHistory, setFobHistory] = useState([]);

    // Fetch fob history on component did mount.
    useEffect(() => {
        const fetchFobs = async () => {
            setLoading(true);

            try {
                const abortSignal = abortSignalRef.current;
                const response = await getFobHistory(abortSignal);

                if (abortSignal.aborted === false && response.length > 0) {

                    // Parse the JSON properties key.
                    response.forEach(element => {
                       element.properties = JSON.parse(element.properties);
                    });

                    setFobHistory(response);
                }

            setLoading(false);
            } catch (error) {
                showMessages(error.message, messageType.error);
                setLoading(false);
                if(error.status_code === 404) window.location.replace('/404');
            }
        }

        fetchFobs()
    }, [refreshFobs]);

    return (
        <Card className="access-key-history" title={<Typography.Text strong>Access Key History</Typography.Text>}>
            <Spin spinning={loading}>
                {fobHistory && fobHistory.length !== 0 ?
                <Timeline mode={'left'} items={
                    fobHistory && fobHistory.length !== 0 ?
                        fobHistory.map((fob, index) => ({
                            key: index,
                            color: (
                                // If true grey, if false check lost event.
                                  fob.properties.event_type === 'bless_event' ? 'grey'
                                // If true gold, if false check revoked.
                                : fob.properties.event_type === 'lost_event' ? 'gold'
                                // If true red, if false green.
                                : fob.properties.isRevoked ? 'red' : 'green'
                                ),
                            label: (
                                <>
                                    <div>{dayjs(fob.properties.isRevoked ? fob.properties.ended_at : fob.properties.started_at).format('DD MMM YYYY')}</div>
                                    <div>{dayjs(fob.properties.isRevoked ? fob.properties.ended_at : fob.properties.started_at).format('h:mm A')}</div>
                                </>
                                ),
                            children: (
                                <>
                                    <div className="bold-type-id-text">
                                        {fob.properties.fob_type === 'awid' ? fob.properties.fob_type.toUpperCase() : ucFirst(fob.properties.fob_type)} {fob.properties.fob_identifier}
                                    </div>
                                    <div className="grey-detail-text">
                                        {
                                            // If true check blessed state, if false check lost event.
                                              fob.properties.event_type === 'bless_event' ?
                                              fob.properties.became_blessed === true ? 'Blessed' : 'Unblessed'
                                            // If true Reported Lost/Stolen, if false check assigned.
                                            : fob.properties.event_type === 'lost_event' ? 'Reported Lost/Stolen'
                                            // If true Unassigned, if false assigned.
                                            : fob.properties.isRevoked ? 'Unassigned' : 'Assigned'
                                        }
                                    </div>
                                    <div className="grey-detail-text">
                                        {`Staff (${fob.properties.email})`}
                                    </div>
                                </>
                            )
                        })) : []
                    }
                /> : <Empty className="empty-component" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
            </Spin>
        </Card>
    )
}

export default AccessKeyHistory

AccessKeyHistory.propTypes = {
    refreshFobs: PropTypes.bool.isRequired,
};
